import { render, staticRenderFns } from "./SpecificationFoods.vue?vue&type=template&id=013cb9d2&"
import script from "./SpecificationFoods.vue?vue&type=script&lang=js&"
export * from "./SpecificationFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports